// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyC97P06YbQF3lZ1CnNcaRQ9b3AH8Z2Dxjg",
    authDomain: "esperanza-hispana-cffc8.firebaseapp.com",
    projectId: "esperanza-hispana-cffc8",
    storageBucket: "esperanza-hispana-cffc8.firebasestorage.app",
    messagingSenderId: "601011057036",
    appId: "1:601011057036:web:144f1b38cfb4f0e9e326a9",
    measurementId: "G-CFNPRXLFLW"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)